module.exports = __webpack_public_path__ + "static/img/mens_test_3.629aa44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blocks/mens_test_3.svg
// module id = HQ2s
// module chunks = 0